import React from 'react';
import { motion } from 'framer-motion';
export function Bonuses() {
  const bonuses = [{
    emoji: '🗓️',
    num: '01',
    title: 'Planilla Maestra',
    desc: '7 minutos y tu semana queda cerrada',
    value: '$8.000'
  }, {
    emoji: '🧊',
    num: '02',
    title: 'Kit No Hay Nada en Casa',
    desc: '50 comidas de rescate con lo que ya tenés',
    value: '$10.000'
  }, {
    emoji: '❄️',
    num: '03',
    title: 'Tu Freezer Te Tiene Que Salvar',
    desc: 'Sistema completo de etiquetado y rotación del freezer',
    value: '$9.000'
  }, {
    emoji: '⏱️',
    num: '04',
    title: '15 Cenas de 12 Minutos',
    desc: 'Recetas express para las noches más complicadas',
    value: '$8.000'
  }, {
    emoji: '🍽️',
    num: '05',
    title: 'Coman sin Protestar',
    desc: 'Estrategias para hogares con gustos difíciles',
    value: '$9.000'
  }, {
    emoji: '🏠',
    num: '06',
    title: 'Tu Cocina Ordenada',
    desc: 'Kit imprimible para organizar tu cocina con lógica real',
    value: '$9.000'
  }];
  return <section className="py-20 px-4 bg-brand-darker" data-id="element-23">
      <div className="max-w-5xl mx-auto" data-id="element-24">
        <div className="text-center mb-12" data-id="element-25">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 flex items-center justify-center gap-3" data-id="element-26">
            <span data-id="element-27">🎁</span> LOS 6 BONOS — SIEMPRE INCLUIDOS
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-28">
          {bonuses.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-card p-6 rounded-2xl border border-brand-gold/20 relative overflow-hidden group hover:border-brand-gold/50 transition-colors" data-id="element-29">
              <div className="absolute top-0 right-0 bg-brand-gold text-black text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-30">
                BONO {bono.num}
              </div>
              <div className="text-4xl mb-4" data-id="element-31">{bono.emoji}</div>
              <h4 className="text-lg font-bold mb-2" data-id="element-32">{bono.title}</h4>
              <p className="text-gray-400 text-sm mb-4 h-10" data-id="element-33">{bono.desc}</p>
              <div className="flex items-center justify-between pt-4 border-t border-white/10" data-id="element-34">
                <span className="text-gray-500 line-through text-sm" data-id="element-35">
                  {bono.value}
                </span>
                <span className="text-brand-gold font-bold" data-id="element-36">GRATIS</span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-brand-gold/10 border border-brand-gold/30 rounded-2xl p-6 max-w-2xl mx-auto" data-id="element-37">
          <p className="text-xl md:text-2xl font-bold" data-id="element-38">
            💰 Valor total bonos:{' '}
            <span className="line-through text-gray-400" data-id="element-39">$53.000</span> →{' '}
            <span className="text-brand-gold" data-id="element-40">GRATIS con tu Pack</span>
          </p>
        </motion.div>
      </div>
    </section>;
}